import _ from 'underscore';
import moment from 'moment';

import flight_domestic_buyer_manage_order_list from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_list'
import flight_domestic_airlines from '@/lib/data-service/flight/flight_domestic_airlines'
import order_cancel from '@/lib/data-service/flight/flight_domestic_buyer_white_order_cancel'
import scrollTop from '@/lib/common-service/scrollTop'
import recordCount from '@/lib/data-service/flight/flight_domestic_buyer_manage_order_recordCount'
import FligthTime from '@/page/distributor/air-ticket/admin/component/flightTimeBox'
import AirlineSelect from '@/page/distributor/air-ticket/components/airlineSelect'

export default {
  components: { FligthTime, AirlineSelect },
  data() {
    return {
      a: '',
      timeUpbox: null,
      timeUpboxHeight: null,
      searchForm: {
        pnr: ``,
        orderNo: ``,
        ticketNumber: ``,
        flightType: '',
        airCode: ``,
        psgName: ``,

        __orderTimeStart: '',
        __orderTimeEnd: ``,

        orderStatus: `1`,
      },
      dialogVisible: false,
      cancelOrderNo: '',
      pageResult: {
        currentPage: 1,
        pageSize: 10,
        pageData: [],
        totalCount: 0,
      },

      data_flight_domestic_airlines: {
        pageResult: {
          pageData: [],
        }
      },
      data_flight_domestic_buyer_manage_order_states: {
        pageResult: {
          pageData: [],
        }
      },
      recordCount: [],
      isFirst: true,
      loading: true,
      NavItemActive: 0,
      pCurrentPage: 1,
      flightTypeList: [
        { label: '全部', value: '' },
        { label: '单程', value: '1' },
        { label: '往返', value: '2' }
      ],

    };
  },

  computed: {
    orderTimeStart: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeStart).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeStart);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
    orderTimeEnd: {
      get() {
        const __this = this;
        const flag = moment(__this.searchForm.__orderTimeEnd).isValid();
        let s = ``;
        if (flag) {
          const d = moment(__this.searchForm.__orderTimeEnd);
          s = d.format(`YYYY/MM/DD`);
        }
        return s;
      }
    },
    getTime() {
      let _this = this
      return function (index) {
        if (_this.searchForm.__orderTimeStart) {
          return _this.searchForm.__orderTimeStart[index]
        } else {
          return ''
        }
      }
    },
  },
  methods: {
    async init () {
      const __this = this;
      const data_flight_domestic_airlines = await flight_domestic_airlines();
      __this.data_flight_domestic_airlines = data_flight_domestic_airlines;
      __this.__data_bind_list();
    },

    async __data_bind_list(pParameter) {
      const __this = this;
      if (!pParameter) pParameter = {};
      const currentPage = pParameter.currentPage || __this.pageResult.currentPage;
      const pageSize = pParameter.pageSize || __this.pageResult.pageSize;
      const pnr = __this.searchForm.pnr;
      const orderNo = __this.searchForm.orderNo;
      const ticketNumber = __this.searchForm.ticketNumber;
      const airCode = __this.searchForm.airCode;
      const psgName = __this.searchForm.psgName;
      const orderStatus = __this.searchForm.orderStatus;
      let _fromData = this.searchForm
      const orderTimeStart = __this.getTime(0)
      const orderTimeEnd = __this.getTime(1)
      let data = {
        currentPage: currentPage,
        pageSize: pageSize,
        pnr: pnr,
        orderNo: orderNo,
        ticketNumber: ticketNumber,
        airCode: airCode,
        psgName: psgName,
        orderStatus: orderStatus,
        orderTimeStart: orderTimeStart,
        placeAnOrderPerson: _fromData.placeAnOrderPerson,
        orderTimeEnd: orderTimeEnd,
        flightNo: _fromData.flightNo,
        flightType: _fromData.flightType,
        contactTel: _fromData.contactTel,
        psgCardNo: _fromData.psgCardNo
      };
      __this.loading = true;

      try {
        recordCount(data).then(res => {
          const list = res.records;
          this.recordCount = list;
          if (this.isFirst) {
            this.isFirst = false;
            const status = Number(__this.$route.query.status);
            if (status) {
              for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item.status === status) {
                  __this.__btn_tab_click(item, i);
                  return;
                }
              }
            } else {

            }
          };
          flight_domestic_buyer_manage_order_list(data).then((result) => {
            __this.loading = false;
            __this.pageResult.pageData = result.pageResult.pageData;
            __this.pageResult.totalCount = result.pageResult.totalCount;
            scrollTop(500)
          }).catch((err) => {
            __this.loading = false;
          });
        }).catch(() => {

        });
      } catch{
        __this.loading = false;
        __this.pageResult.pageData = []
        __this.pageResult.totalCount = 0
      }
    },

    __el_pagination_current_change_event_handler(pCurrentPage) {
      const __this = this;
      __this.pageResult.currentPage = pCurrentPage
      __this.__data_bind_list();
    },

    setOrdersNo(ordersNo, toString, psgList, manualStatus) {
      let psgType
      if (psgList) {
        let psg = psgList.map(item => {
          return item.psgType
        })
        if (psg.indexOf(1) != -1) {
          psgType = 1
        } else {
          manualStatus == 1 ? psgType = 3 :
            psgType = 2
        }
      }
      this.$router.push({
        name: toString,
        query: {
          ordersNo,
          psgType
        }
      })
    },
    apply(orderNo) {
      this.$router.push({ name: 'air-ticket-admin-strokeOrder' });
    },
    cancel(ordersNo) {
      let parame = {
        orderNo: ordersNo,
        remark: ''
      }
      order_cancel(parame).then(res => {
        res.isSuccess ?
          this.$message({ type: "warning", message: "操作成功！" }) : ''
        this.__data_bind_list({ currentPage: this.pCurrentPage });
      })
    },
    __el_pagination_size_change_event_handler(pPageSize) {
      const __this = this;
      __this.pageResult.pageSize = pPageSize
      __this.__data_bind_list();
    },

    __btn_search_click() {
      const __this = this;
      __this.__data_bind_list({ currentPage: 1 });
    },

    __btn_reset_click() {
      const __this = this;

      _.each(__this.searchForm, function (property_value, property_name) {
        __this.searchForm[property_name] = ``;
      });
      __this.searchForm.orderStatus = `1`;

      __this.__data_bind_list();
    },

    __btn_tab_click(pItem, pIndex) {
      const __this = this;
      __this.searchForm.orderStatus = pItem.status;
      __this.NavItemActive = pIndex;
      this.pageResult.currentPage = 1
      __this.__btn_search_click();
    },
    offHeight(e) {
      this.timeUpboxHeight = e.target.offsetParent.offsetHeight;
    },
  },
  watch: {
    '$route.query.ordersNo': function (newId) {
      this.__data_bind_list()
    },
  },
  mounted() {
    this.init();
  },
}
